/*
 * Copyright 2019 FedEx
 */
export const appConstants = {

    NO_CONTENT_204_SUBMIT_MSG: 'AWB number is invalid!',

    HS_CODE_TOOL_TIP_NL: 'HS Codes (or HTS Codes), also known as the Harmonized Commodity Description and Coding System,'
        + ' or simply the Harmonized System, are a standardized international system to classify globally traded products.'
        + ' ... As signatories, each country agrees to classify its tariff and duty structure according to the HS Code '
        + ' categories. Harmonized codes can be found on the '
        + ' <a target="_blank" href="https://tarief.douane.nl/arctictariff-public-web/#!/taric/nomenclature/sbt">Dutch customs site</a>.',
    
    HS_CODE_TOOL_TIP_PH: 'HS Codes (or HTS Codes), also known as the Harmonized Commodity Description and Coding System,'
        + ' or simply the Harmonized System, are a standardized international system to classify globally traded products.'
        + ' ... As signatories, each country agrees to classify its tariff and duty structure according to the HS Code '
        + ' categories.',    

    EORI_TOOL_TIP: ' <div> Please click here if you need more information and/or to register for an EORI number </div> '
        + ' <div><label>For English:</label> '
        + ' <a href="https://belastingdienst.nl/wps/wcm/connect/bldcontenten/belastingdienst/customs/eori/eori-number/" target="_blank" class="linkStyle01">Click here</a></div> '
        + ' <div class="padBottom20"><label>For Netherlands:</label> '
        + ' <a class="linkStyle01" href="https://www.belastingdienst.nl/wps/wcm/connect/nl/douane_voor_bedrijven/content/wat-is-een-eori-nummer" target="_blank">Click here</a> '
        + ' </div> ',

    VAT_TOOL_TIP: '<div> If your company is new, please contact the Chamber of Commerce: </div>'
        + ' <a target="_blank" href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/ondernemen/onderneming_starten/schrijf_uw_bedrijf_in_bij_de_kamer_van_koophandel/schrijf_uw_onderneming_in"> '
        + ' Click here</a> ',

    ITEM_DESC_TOOL_TIP: 'Item description should be as detailed as possible, please add the information such as ' +
        'what is it? How many are there? What is it made from? What is the intended use? Etc.',

    UPLOAD_FILE_TOOL_TIP: 'Please share the file in the format of pdf, doc, docx, xls, xlsx, csv, jpg, jpeg, gif or png.',

    ERROR_204: 204,
    ERROR_400: 400,
    ERROR_404: 404,
    ERROR_500: 500,

};
